/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'security';
const componentName = 'ssl-certificate-imported-information';
const prefix = `${moduleName}.${componentName}`;

export const commonNameInputLabel = `${prefix}.commonNameInputLabel`;
export const emailInputLabel = `${prefix}.emailInputLabel`;
export const organizationInputLabel = `${prefix}.organizationInputLabel`;
export const organizationUnitInputLabel = `${prefix}.organizationUnitInputLabel`;
export const algorithmInputLabel = `${prefix}.algorithmInputLabel`;
export const keySizeInputLabel = `${prefix}.keySizeInputLabel`;
export const validUntilInputLabel = `${prefix}.validUntilInputLabel`;
export const importedInformationHeader = `${prefix}.importedInformationHeader`;

export const ENGLISH = {
    [commonNameInputLabel]: 'Common Name',
    [emailInputLabel]: 'Email',
    [organizationInputLabel]: 'Organization',
    [organizationUnitInputLabel]: 'Organization Unit',
    [algorithmInputLabel]: 'Algorithm',
    [keySizeInputLabel]: 'Key Size',
    [validUntilInputLabel]: 'Valid Until',
    [importedInformationHeader]: 'Imported Information',
};
